

import {useContext, useEffect, useState} from 'react';
import DepartamentContext from 'context/DepartamentContext';
import {
 getAll,
 create,
 update,
 del
} from 'services/DepartamentService.js'
import Swal from 'sweetalert2'


let totalPages;


export function useDepartament(){
 const [page, setPage] = useState(1);
 const [itemsPerPage, setItemsPerPage] = useState(5)


 const {
  allDepartaments, 
  setAllDepartaments,
  departaments, 
  setDepartaments, 
  setMessage, 
  message,
  loading, 
  setLoading} = useContext(DepartamentContext);

 
 const getAllDepartaments = async ({codeLogistic, departament, town, status}) => {
  try{
   const response = await getAll({codeLogistic, departament, town, status});
   setAllDepartaments(response)
   return response
  }catch(err){
   const {data, status} = err.response;
   setMessage({message: data.message, status});
  }
 }

 const getDepartaments = async ({page = 1, limit = itemsPerPage, codeLogistic, departament, town, status}) => {
     setLoading(true);
     setPage(page);
     try{
         const allDepartaments = await getAllDepartaments({codeLogistic, departament, town, status});
         setAllDepartaments(allDepartaments);
         totalPages = Math.ceil(allDepartaments.length / limit);
         const departaments = await getAll({page, limit, codeLogistic, departament, town, status});
         setDepartaments(departaments);
         setLoading(false);
     }catch(err){
         console.log(err);
         const {data, status} = err.response;
         setMessage({message: data.message, status})
         setLoading(false);
     }
 }

 const deleteDepartament = async ({id}) => {
     Swal.fire({
     title: 'Estás seguro?',
     text: '¡No podrás revertir esto!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Si, eliminar!',
     cancelButtonText: 'Cancelar'
     }).then((result) => {
     if (result.isConfirmed) {
        (async() => {
            try{
                const {message} = await del({id})
                setMessage({message: '', status: 200})
                
                Swal.fire(
                'Éxito!!!',
                message,
                'success'
                )
                getDepartaments({page})
            }catch(err){
                const {data, status} = err.response
                setMessage({message: data.message, status})
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.message,
                })
            }
        })();
    }
    })
 }

 const updateDepartament = async ({departament, id}) => {
    try{
        const {message} = await update({departament, id})
        setMessage({message: '', status: 200})
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getDepartaments({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 const createDepartament = async ({departament}) => {
     try{
        const {message} = await create({departament})
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getDepartaments({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 useEffect(() => {
  getDepartaments({});
  // eslint-disable-next-line
 }, [])

 return {
    allDepartaments, 
    departaments, 
    page, 
    totalPages, 
    status: message.status, 
    loading, 
    deleteDepartament, 
    updateDepartament, 
    createDepartament, 
    getDepartaments, 
    setPage,
    itemsPerPage,
    setItemsPerPage,
 }
}